import React, { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "@app/services/error-reporter";
import { AppErrorFallback } from "./AppErrorFallback";

interface AppErrorBoundaryProps {
    children: ReactNode;
}

interface AppErrorBoundaryState {
    hasError: boolean;
    errorMessage: string | null;
}

/**
 * Ловит ошибки рендера/lifecycle и показывает мобильный fallback.
 */
export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
    constructor(props: AppErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, errorMessage: null };
    }

    static getDerivedStateFromError(error: Error): AppErrorBoundaryState {
        return {
            hasError: true,
            errorMessage: error.message,
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        reportError(error, {
            from: "AppErrorBoundary",
            context: errorInfo,
            dedupeKey: `boundary:${error.message}`,
        });
    }

    private handleReload = (): void => {
        this.setState({ hasError: false, errorMessage: null });
    };

    render(): ReactNode {
        if (this.state.hasError) {
            return <AppErrorFallback message={this.state.errorMessage ?? undefined} onReload={this.handleReload} />;
        }

        return this.props.children;
    }
}
